var res = [{"key":"10/11","value":"32","value2":"0.15"},{"key":"11/12","value":"28","value2":"0.12"},{"key":"12/13","value":"32","value2":"0.16"},{"key":"13/14","value":"9","value2":"0.05"},{"key":"14/15","value":"11","value2":"0.06"},{"key":"15/16","value":"5","value2":"0.03"},{"key":"16/17","value":"5","value2":"0.03"}];res.columns = ["key","value","value2"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/focus-1.csv
// module id = 612
// module chunks = 0